import ServerErrorModal from "../organisms/ServerErrorModal";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import ReagendamientoModal from "./ReagendamientoModal";
import { useListarFechasReservadasSpa } from "../../services/reservasSpaServicios";
import {
  reagendarSpa,
  useBuscarAgendamientoDeReservaSpa,
} from "../../services/agendamientosSpaServicios";
import {
  IAsistenciaProyectadaSpa,
  QUERY_OBTENER_ASISTENCIA_DIARIA_SPA,
  QUERY_OBTENER_LISTAS_ASISTENCIAS_PROYECTADAS_SPA,
} from "../../services/asistenciaSpaServicios";

function ReagendamientoSpaModal({
  itemAsistencia,
  onClose,
  fecha,
  idReserva,
}: {
  itemAsistencia: IAsistenciaProyectadaSpa;
  idReserva: string;
  fecha: Date;
  onClose: () => void;
}) {
  const queryClient = useQueryClient();

  const {
    data: agendamientoSpa,
    isError: isErrorAgendamientoSpa,
  } = useBuscarAgendamientoDeReservaSpa(idReserva, true);

  const {
    data: fechasProyectadas,
    isLoading: isLoadingFechasProyectadas,
    isError: isErrorFechasProyectadas,
  } = useListarFechasReservadasSpa(itemAsistencia.idMascota);

  const mutacionReagendarSpa = useMutation(reagendarSpa, {
    onSuccess: () => {
      queryClient.invalidateQueries([
        QUERY_OBTENER_LISTAS_ASISTENCIAS_PROYECTADAS_SPA,
        QUERY_OBTENER_ASISTENCIA_DIARIA_SPA,
      ]);

      onClose();
    },
  });

  const onGuardarClick = (fechasReemplazadas: Map<string, string>) => {
    if (!agendamientoSpa) return;
    mutacionReagendarSpa.mutate({
      idAgendamiento: agendamientoSpa.id,
      request: {
        fechas: Object.fromEntries(fechasReemplazadas),
        idReservaSpa: idReserva,
      },
    });
  };

  const isError =
    isErrorFechasProyectadas ||
    isErrorAgendamientoSpa ||
    mutacionReagendarSpa.isError;

  if (isError) {
    return <ServerErrorModal onClose={onClose} />;
  }

  return (
    <ReagendamientoModal
      fechasIsLoading={isLoadingFechasProyectadas}
      onGuardar={onGuardarClick}
      onClose={onClose}
      fechasOcupadas={fechasProyectadas || []}
      fecha={fecha}
      itemAsistencia={itemAsistencia}
    />
  );
}

export default ReagendamientoSpaModal;
